import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { AbstractAssetEditComponent, mapStateToProps } from './abstract'
import { Button, Input, Checkbox, TextArea } from '~/components/form'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import * as route from '~/helper/constant/route'
import { Loading } from '~/components/loader'
import { withTranslation } from 'react-i18next'
import { convertADtoBS } from '~/helper/function'

class AssetEditComponent extends AbstractAssetEditComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this._purchaseDate = this._purchaseDate.bind(this)
        this._supportedDate = this._supportedDate.bind(this)
    }
    _purchaseDate(data) {
        this._handleChange('purchase_date', data)
    }
    _supportedDate(data) {
        this._handleChange('supported_date', data)
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text="Saving" />
                <Sidebar id="assets" isAccount={true} />
                <Loading status={this.state.loading} text={this.state.loading_text} />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; </a>
                            </li>
                            <li>
                                <a href={route.admin.accounting.asset.view}>
                                    {t('doubleentry:assets')} &nbsp; &gt; &nbsp;
                                </a>
                            </li>
                            <li>{t('common:EditBtn')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('income:editAsset')} :</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <form>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('common:name')} *</label>
                                    <Input
                                        name="name"
                                        onChange={this._handleChange}
                                        placeholder={t('common:name')}
                                        type="text"
                                        value={this.state.name}
                                    />
                                    {this.state.errors.name && (
                                        <label className="error text-danger">{this.state.errors.name}</label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('fee:fee_amount')} *</label>
                                    <Input
                                        onChange={this._handleChange}
                                        name="amount"
                                        type="text"
                                        placeholder={t('fee:fee_amount')}
                                        value={this.state.amount}
                                    />
                                    {this.state.errors.amount && (
                                        <label className="error text-danger">{this.state.errors.amount}</label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('income:purchaseDate')} *</label>
                                    {this.state.purchase_date !== undefined && this.state.purchase_date !== '' && (
                                        <DatePicker
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control"
                                            placeholderText={t('income:purchaseDate')}
                                            onChange={this._purchaseDate}
                                            selected={
                                                this.state.purchase_date ? new Date(this.state.purchase_date) : null
                                            }
                                        />
                                    )}
                                    {this.props.school != null &&
                                        this.props.school.school != null &&
                                        this.props.school.school.date_format == 'BS' && (
                                            <label className="date-bs">
                                                {this.state.purchase_date != ''
                                                    ? convertADtoBS(this.state.purchase_date) != null
                                                        ? convertADtoBS(this.state.purchase_date) + ' BS'
                                                        : 'Invalid Date Range'
                                                    : ''}
                                            </label>
                                        )}

                                        {this.state.errors.purchase_date && (
                                        <label className="error text-danger setup-error text-left">
                                            {this.state.errors.purchase_date}
                                        </label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('income:supportedDate')} *</label>
                                    {this.state.supported_date !== undefined && this.state.supported_date !== '' && (
                                        <DatePicker
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control"
                                            placeholderText={t('income:supportedDate')}
                                            onChange={this._supportedDate}
                                            selected={
                                                this.state.supported_date ? new Date(this.state.supported_date) : null
                                            }
                                        />
                                    )}
                                    {this.props.school != null &&
                                        this.props.school.school != null &&
                                        this.props.school.school.date_format == 'BS' && (
                                            <label className="date-bs">
                                                {this.state.supported_date != ''
                                                    ? convertADtoBS(this.state.supported_date) != null
                                                        ? convertADtoBS(this.state.supported_date) + ' BS'
                                                        : 'Invalid Date Range'
                                                    : ''}
                                            </label>
                                        )}
                                        {this.state.errors.supported_date && (
                                        <label className="error text-danger setup-error text-left">
                                            {this.state.errors.supported_date}
                                        </label>
                                    )}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('common:description')}</label>
                                    <TextArea
                                        name="description"
                                        onChange={this._handleChange}
                                        value={this.state.description}
                                        placeholder={t('common:description')}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="form-button text-left">
                        <Button onClick={this.onSave} type="submit" text={t('common:savebtn')} main={true} />
                    </div>
                </div>
            </div>
        )
    }
}
const AssetEdit = withTranslation()(connect(mapStateToProps)(AssetEditComponent))
export { AssetEdit }
